module.exports = __webpack_public_path__ + "static/media/image7.591f6b1c.png";